import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorPublicInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M17.25 16.5a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0 0 1.5h10.5ZM11 12.625c0 .345-.28.625-.625.625h-3.75a.625.625 0 1 1 0-1.25h3.75c.345 0 .625.28.625.625Zm-.625-2.375a.625.625 0 1 0 0-1.25h-3.75a.625.625 0 1 0 0 1.25h3.75Zm0-3a.625.625 0 1 0 0-1.25h-3.75a.625.625 0 1 0 0 1.25h3.75Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19 3.5H5a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5ZM5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M13 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V7Z"
    />
  </svg>
);
export default SvgTwoColorPublicInformation;
